(ns teamoesterreich.admin-mode.navigation.bottom-bar
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.text.get-text :as txt]

            [teamoesterreich.admin-mode.actions :as a]

            ))




(defn set-actions [& [bottom-back-fn bottom-save-fn]]
  (js/console.log "set bottom-nav-bar " bottom-back-fn bottom-save-fn)
  (swap! store/app-state assoc :bottom-back-fn bottom-back-fn)
  (swap! store/app-state assoc :bottom-save-fn bottom-save-fn)
  )
;; see https://material-ui.com/components/bottom-navigation/


(a/register-bottom-bar-back-action-set set-actions)


(defn impressum-line []
  (let [!actual-user (r/cursor store/app-state [:actual-user])]
    [:div
     (str (txt/txt :core "footer") " -- Admin Mode " (get-in @!actual-user [:name :first]) " " (get-in @!actual-user [:name :last]) "")
     " | " [:a {:href "" :onClick #(do (a/set-page :impressum (get-in @store/app-state [:state :site])) (.preventDefault %))} "Impressum"]
     " | " [:a {:href "" :onClick #(do (a/set-page :dsgvo (get-in @store/app-state [:state :site])) (.preventDefault %))} "Datenschutz"]
     ]
    ))

(defn bar []
  (let []
    [mui/bottom-navigation {:style {:height 50 :padding 20 :backgroundColor "white"}}
     [impressum-line]
     ]
    ))


